import React, { Component } from "react"
import PropTypes from "prop-types"
import { noop } from "utils"
import { withRadium, ConnectLocation } from "higher-order-components"
import { load } from "../../apis/persist"

class LocationText extends Component {
  constructor(props) {
    super(props)

    if (!load("locality")) {
      const { updatePostcode } = this.props.locationActions;
     // updatePostcode(load("postcode"))
      updatePostcode('2601');
    }
  }

  render() {
    const { fallbackText } = this.props
    return <div>{load("locality") || fallbackText}</div>
  }
}

export default withRadium(ConnectLocation())(LocationText)

LocationText.propTypes = {
  fallbackText: PropTypes.string,
  locationState: PropTypes.object,
  locationActions: PropTypes.object
}

LocationText.defaultProps = {
  fallbackText: "Right here",
  locationState: {},
  locationActions: {
    updatePostcode: noop
  }
}



// WEBPACK FOOTER //
// ./src/components/location-text/index.jsx